import React, { useEffect, useState } from "react";
import {
    INITIAL_PARTIAL_PAY } from "./RestBillConstants";
import {
  BillStatus,
  CART_INITIAL_STATE,
  CASHPAY,
  getDeviceTypeNew,
  InternalBillType,
  isEmpty,
  isNumberEmpty,
  ONLINEPAY,
  printDebugLog,
  SUCCESS,
  UPDATEPARTIALPAY
} from "../../../constants/constant";
import { useDispatch, useSelector } from "react-redux";
import {
  Autocomplete,
  Box,
  Checkbox,
  Dialog,
  FormControlLabel,
  FormLabel,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "../../ui";
import SnpButton from "../../global/SnpButton";
import DismissButton from "../../global/DismissButton";
import { snpAxios } from "../../global/api";
import DialogBox from "../../global/DialogBox";
import { useSnpUI } from "../../global/snpComponent/SnpUiProvider";
import { handleInvoicePrint } from "../../../utilities/printUtils";
import {
  fetchBillDetails,
  fetchBillPartialPayDetails,
  updateBillDetails,
  updateBillPartialPaymentDetails,
} from "../../../store/billDetailsSlice";
import { useDeviceType } from "../../global/hooks/useDeviceType";
import { set } from "lodash";

const PartialPayDialog = ({
  showDialog,
  setShowDialog,
  handleInitiatePayment,
  setShowCustCopyDialog,
  setPrintDetails,
}) => {
  const [partialPay, setPartialPay] = useState(INITIAL_PARTIAL_PAY);
  const [currentDues, setCurrentDues] = useState(0);
  const { billDetails, billCustomerDetails, billPartialPaymentDetails } =
    useSelector((state) => state.bill);
  const storeActiveShopHash = useSelector(
    (state) => state.setActiveShopHashReducer.activeShopHash
  );
  const storeApiUrl = useSelector(
    (state) => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL
  );

  const { isMobile, isTablet } = useDeviceType(getDeviceTypeNew);
  const dispatch = useDispatch();

  // useEffect(() => {
  //   if (billDetails.biilNo && !isEmpty(billDetails.biilNo)) {
  //     dispatch(fet(billDetails.biilNo));
  //   }
  //   console.log("billDetails partialPay: ", billDetails);

  // },[]);
  useEffect(() => {
    //dispatch(fetchBillPartialPayDetails(billDetails.billNo));
  }, [billDetails]);

  useEffect(() => {
    printDebugLog("setting current dues: ", billPartialPaymentDetails.duesAmt);
    setCurrentDues(billPartialPaymentDetails.duesAmt);
  }, [billPartialPaymentDetails]);
  const { snackbar, loader, dialog, notify } = useSnpUI();
  useEffect(() => {}, []);
  const enableDisableOnlineCashPay = () => {
    let status = billDetails.billStatus === BillStatus.PAID;
    if (!status) {
      status =
        isEmpty(partialPay.onlineBillPaidThrough) ||
        isEmpty(partialPay.cashBillPaidThrough);
    }
    return status;
  };
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    //printLog("handleInputChange", name, value);
    if (name === "partialAmt") {
      if (!isNumberEmpty(value)) {
        if (parseFloat(value) > parseFloat(billPartialPaymentDetails.duesAmt)) {
          snackbar.show({
            message:
              "Exceeds Remaining Amt i.e " + billPartialPaymentDetails.duesAmt,
            color: "orange",
          });
          setCurrentDues(billPartialPaymentDetails.duesAmt);
          setPartialPay({
            ...partialPay,
            partialAmt: 0,
            onlineBillPaidThrough: "",
            onlinePay: 0,
            cashBillPaidThrough: "",
            cashPay: 0,
            cashTendered: 0,
            cashReturn: 0,
          });
        } else {
          let dues =
            parseFloat(billPartialPaymentDetails.duesAmt) - parseFloat(value);
          setPartialPay({
            ...partialPay,
            partialAmt: parseFloat(value),
            onlineBillPaidThrough: "",
            onlinePay: 0,
            cashBillPaidThrough: "",
            cashPay: 0,
            cashTendered: 0,
            cashReturn: 0,
          });
          setCurrentDues(dues);
        }
      } else {
        setPartialPay({
          ...partialPay,
          partialAmt: 0,
          onlineBillPaidThrough: "",
          onlinePay: 0,
          cashBillPaidThrough: "",
          cashPay: 0,
          cashTendered: 0,
          cashReturn: 0,
        });
        setCurrentDues(billPartialPaymentDetails.duesAmt);
      }
    } else if (name === "cashPayAmt") {
      let rt = partialPay.partialAmt;
      if (isEmpty(value)) {
        setPartialPay({
          ...partialPay,
          cashPay: 0.0,
          onlinePay: isEmpty(partialPay.onlineBillPaidThrough) ? 0.0 : rt,
          cashTendered: 0,
          cashReturn: 0,
        });
      } else {
        if (parseFloat(value) > rt) {
          // setSnpComponent({
          //     ...snpComponent,
          //     snackBarOpen: true,
          //     snackBarMsg: "Exceeds Remaining Amt i.e " + rt,
          // });
          snackbar.show({
            message: "Exceeds Remaining Amt i.e " + rt,
            color: "red",
          });
        } else {
          let mOnlinePay = !isEmpty(partialPay.onlineBillPaidThrough)
            ? rt - parseFloat(value)
            : 0.0;
          setPartialPay({
            ...partialPay,
            cashPay: parseFloat(value),
            onlinePay: mOnlinePay,
            onlineBillPaidThrough:
              mOnlinePay === 0.0 ? "" : partialPay.onlineBillPaidThrough,
            cashTendered: 0,
            cashReturn: 0,
          });
        }
      }
    } else if (name === "cashPay") {
      //printLog("cashPay",partialPay);

      let val = isEmpty(partialPay.cashBillPaidThrough) ? CASHPAY : "";
      //printLog("val",val);
      let rt = partialPay.partialAmt;
      if (rt > 0) {
        setPartialPay({
          ...partialPay,
          cashBillPaidThrough: val,
          cashPay: !isEmpty(partialPay.onlineBillPaidThrough)
            ? !isEmpty(val)
              ? rt / 2
              : 0.0
            : !isEmpty(val)
            ? rt
            : 0.0,
          onlinePay: !isEmpty(partialPay.onlineBillPaidThrough)
            ? !isEmpty(val)
              ? rt / 2
              : rt
            : 0.0,
          cashTendered: 0,
          cashReturn: 0,
          isCashPayEnabled: event.target.checked,
        });
      } else {
        // setSnpComponent({
        //     ...snpComponent,
        //     snackBarOpen: true,
        //     snackBarMsg: "Please Enter Amount to be Paid",
        // });
        snackbar.show({
          message: "Please Enter Amount to be Paid",
          color: "red",
        });
      }
    } else if (name === "onlinePay") {
      //printLog("CART_INITIAL_STATE.onlinePayMethod",CART_INITIAL_STATE.onlinePayMethod);;

      let val = isEmpty(partialPay.onlineBillPaidThrough)
        ? CART_INITIAL_STATE.onlinePayMethod[0]
        : "";
      let rt = partialPay.partialAmt;
      if (rt > 0) {
        setPartialPay({
          ...partialPay,
          onlineBillPaidThrough: val,
          onlinePayMedium: val, // Both var should be same need to check
          cashPay: !isEmpty(partialPay.cashBillPaidThrough)
            ? !isEmpty(val)
              ? rt / 2
              : rt
            : 0.0,
          onlinePay: !isEmpty(partialPay.cashBillPaidThrough)
            ? !isEmpty(val)
              ? rt / 2
              : 0.0
            : !isEmpty(val)
            ? rt
            : 0.0,
          cashTendered: 0,
          cashReturn: 0,
          isOnlinePayEnabled: event.target.checked,
        });
      } else {
        // setSnpComponent({
        //     ...snpComponent,
        //     snackBarOpen: true,
        //     snackBarMsg: "Please Enter Amount to be Paid",
        // });
        snackbar.show({
          message: "Please Enter Amount to be Paid",
          color: "red",
        });
      }
    } else if (name === "onlinePayAmt") {
      let rt = partialPay.partialAmt;
      if (isEmpty(value)) {
        setPartialPay({
          ...partialPay,
          cashPay: isEmpty(partialPay.cashBillPaidThrough) ? 0.0 : rt,
          onlinePay: 0.0,
          cashTendered: 0,
          cashReturn: 0,
        });
      } else {
        if (parseFloat(value) > rt) {
          // setSnpComponent({
          //     ...snpComponent,
          //     snackBarOpen: true,
          //     snackBarMsg: "Exceeds Remaining Amt i.e " + rt,
          // });
          snackbar.show({
            message: "Exceeds Remaining Amt i.e " + rt,
            color: "red",
          });
        } else {
          let mCashPay = !isEmpty(partialPay.cashBillPaidThrough)
            ? rt - parseFloat(value)
            : 0.0;
          setPartialPay({
            ...partialPay,
            onlinePay: parseFloat(value),
            cashPay: mCashPay,
            cashBillPaidThrough:
              mCashPay === 0.0 ? "" : partialPay.cashBillPaidThrough,
            cashTendered: 0,
            cashReturn: 0,
          });
        }
      }
    } else if (name === "cashTender") {
      if (isNumberEmpty(value)) {
        setPartialPay({
          ...partialPay,
          cashTendered: 0.0,
          cashReturn: 0.0,
        });
      } else {
        let tot = 0.0;
        if (!isEmpty(partialPay.onlineBillPaidThrough))
          tot = partialPay.cashPay;
        else tot = partialPay.partialAmt;
        let rt = parseFloat(value) - tot;
        if (rt >= 0.0) {
          setPartialPay({
            ...partialPay,
            cashTendered: parseFloat(value),
            cashReturn: rt,
          });
        } else {
          setPartialPay({
            ...partialPay,
            cashTendered: parseFloat(value),
            cashReturn: 0.0,
          });
          if (rt < 0.0) {
            // setSnpComponent({
            //     ...snpComponent,
            //     snackBarOpen: true,
            //     snackBarMsg: "Cash Tender should be more or same as Cash Amount i.e " + tot,
            // });
            snackbar.show({
              message:
                "Cash Tender should be more or same as Cash Amount i.e " + tot,
              color: "red",
            });
          }
        }
      }
    }
  };

  const handleSelectChange = (event, payMethod) => {
    printDebugLog("handleSelectChange", payMethod);
    if (payMethod != null) {
      setPartialPay({
        ...partialPay,
        onlineBillPaidThrough: payMethod,
        onlinePayMedium: payMethod,
      });
    } else {
      setPartialPay({
        ...partialPay,
        onlineBillPaidThrough: "",
        onlinePayMedium: "",
      });
    }
  };

  const getPartialPaidThrough = (val) => {
    if (val.onlineBillPaidThrough && val.cashBillPaidThrough) {
      return (
        val.onlineBillPaidThrough +
        "(" +
        val.onlinePay +
        ") " +
        val.cashBillPaidThrough +
        "(" +
        val.cashPay +
        ")"
      );
    } else if (val.onlineBillPaidThrough) return val.onlineBillPaidThrough;
    else return val.cashBillPaidThrough;
  };
  const renderClearDues = () => {
    return (
      <>
        <Grid
          container
          spacing={1}
          justifyContent="center"
          alignItems="center"
          sx={{
            padding: 0,
            margin: 0,
          }}
        >
          <Grid item md={7} xs={12} sm={12}>
            <Typography variant="p" color="#02056e" fontWeight="bold">
              Remaining Amt To Paid ₹{billPartialPaymentDetails.duesAmt}
            </Typography>
          </Grid>
          <Grid item md={4} sm={12} xs={12}>
            <TextField
              style={{ width: "180px" }}
              value={partialPay.partialAmt}
              id="partialAmt"
              name="partialAmt"
              disabled={
                billDetails.billStatus === BillStatus.PAID ||
                billDetails.billStatus === BillStatus.HOMEDELIVERYCASHPAY ||
                billDetails.billStatus === BillStatus.HOMEDELIVERYPAY
              }
              label="Enter Amount Paid"
              variant="filled"
              size="small"
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item md={4} xs={12} sm={12}>
            <center>
              <Typography variant="p" color="#3e0109" fontWeight="bold">
                Current Remaining Dues ₹{currentDues}
              </Typography>
            </center>
          </Grid>

          <Grid item md={12} xs={12} sm={12}>
            <FormLabel id="paymentMethod">
              {" "}
              <p>
                <u>Payment Methods:</u>{" "}
              </p>
            </FormLabel>
          </Grid>
          <Grid item xs={12} md={2} sm={6}>
            <FormControlLabel
              disabled={billDetails.billStatus === BillStatus.PAID}
              control={
                <Checkbox
                  checked={!!partialPay.isOnlinePayEnabled}
                  name="onlinePay"
                  value={ONLINEPAY}
                  onChange={handleInputChange}
                />
              }
              label="Online"
            />
          </Grid>
          <Grid item xs={12} md={5} sm={6}>
            <Autocomplete
              id="pOnline-select"
              options={CART_INITIAL_STATE.onlinePayMethod}
              autoHighlight
              variant="filled"
              size="small"
              fullWidth
              disabled={
                billDetails.billStatus === BillStatus.PAID ||
                isEmpty(partialPay.onlinePayMedium)
              }
              onChange={handleSelectChange}
              isOptionEqualToValue={(option, value) => {
                if (!option) return false;
                if (!value) return false;
                return option === value;
              }}
              getOptionLabel={(option) => option || ""}
              value={partialPay.onlinePayMedium}
              defaultValue={partialPay.onlinePayMedium}
              renderOption={(props, option) => (
                <Box component="li" {...props} key={`${option}`}>
                  {option}
                </Box>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Search Online Pay Method"
                  inputProps={{
                    ...params.inputProps,
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={5} sm={6}>
            <TextField
              id="onlinePayAmt"
              name="onlinePayAmt"
              variant="filled"
              size="small"
              fullWidth
              disabled={enableDisableOnlineCashPay()}
              label="Enter Online Amount"
              value={partialPay.onlinePay.toString()}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={12} md={2} sm={6}>
            <FormControlLabel
              disabled={billDetails.billStatus === BillStatus.PAID}
              control={
                <Checkbox
                  checked={!!partialPay.isCashPayEnabled}
                  name="cashPay"
                  value={CASHPAY}
                  onChange={handleInputChange}
                />
              }
              label="Cash"
            />
          </Grid>
          <Grid item xs={12} md={5} sm={6}>
            <TextField
              id="cashPayAmt"
              name="cashPayAmt"
              variant="filled"
              size="small"
              fullWidth
              disabled={enableDisableOnlineCashPay()}
              label="Enter Cash Amount"
              value={partialPay.cashPay.toString()}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={12} md={5} sm={6}>
            <TextField
              id="cashTender"
              name="cashTender"
              variant="filled"
              size="small"
              fullWidth
              disabled={
                billDetails.billStatus === BillStatus.PAID ||
                isEmpty(partialPay.cashBillPaidThrough)
              }
              label="Enter Cash Tender"
              value={partialPay.cashTendered}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={12} md={5} sm={6}>
            {partialPay.cashReturn > 0.0 && (
              <Typography
                variant="subtitle4"
                component="div"
                style={{ color: "#A52A2A" }}
              >
                Cash Return: ₹{partialPay.cashReturn}
              </Typography>
            )}
          </Grid>
        </Grid>
        {billPartialPaymentDetails.lpatialAmt &&
          billPartialPaymentDetails.lpatialAmt.length > 0 && (
            <TableContainer component={Paper}>
              <Table aria-label="simple table" className="rate_card">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">Paid On</TableCell>
                    <TableCell align="center">Accept By</TableCell>
                    <TableCell align="center">Amount</TableCell>
                    <TableCell align="center">Paid Through</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {billPartialPaymentDetails.lpatialAmt.map((val, index) => {
                    return (
                      <TableRow
                        key={index}
                        className="rate_card--row"
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell align="center">
                          <p
                            style={{
                              whiteSpace: "pre-wrap",
                              overflowWrap: "break-word",
                            }}
                          >
                            {val.paidOn}
                          </p>
                        </TableCell>
                        <TableCell align="center">{val.paidAcceptBy}</TableCell>
                        <TableCell align="center">{val.partialAmt}</TableCell>
                        <TableCell align="center">
                          <p
                            style={{
                              whiteSpace: "pre-wrap",
                              overflowWrap: "break-word",
                            }}
                          >
                            {getPartialPaidThrough(val)}
                          </p>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          )}
      </>
    );
  };

  const updatePartial = async () => {
    console.log("handleUpdatePartial from PartialPayDialog: ");
    let isError = false;
    if (
      billDetails.billStatus === BillStatus.INITIATED ||
      billDetails.billStatus === BillStatus.NO_ENTRY
    ) {
      handleInitiatePayment(true , partialPay);
      setShowDialog(false);
      setPartialPay(INITIAL_PARTIAL_PAY);
      setCurrentDues(billPartialPaymentDetails.duesAmt); //TODO: revisit this once
    } else {
      if (
        billDetails.billType !== InternalBillType.Home &&
        isEmpty(billCustomerDetails.custMob)
      ) {
        isError = true;
        // setSnpComponent({
        //   ...snpComponent,
        //   snackBarMsg: "Please Add Customer Details",
        //   snackBarOpen: true,
        // });
        snackbar.show({ message: "Please Add Customer Details", color: "red" });
      }
      if (
        isEmpty(partialPay.onlineBillPaidThrough) &&
        isEmpty(partialPay.cashBillPaidThrough)
      ) {
        isError = true;
        //printLog()
        // setSnpComponent({
        //   ...snpComponent,
        //   snackBarMsg: "Please Select any of the Payment method",
        //   snackBarOpen: true,
        // });
        snackbar.show({
          message: "Please Select any of the Payment method",
          color: "red",
        });
      }
      if (isNumberEmpty(parseFloat(partialPay.partialAmt))) {
        isError = true;
        // setSnpComponent({
        //   ...snpComponent,
        //   snackBarMsg: "Please Add Partial Amount",
        //   snackBarOpen: true,
        // });
        snackbar.show({ message: "Please Add Partial Amount", color: "red" });
      }
      if (isError) return;
      loader.show();
      let custSaveUrl = storeApiUrl.BACKEND_BASE_URL + UPDATEPARTIALPAY;
      let jcJson = {
        apiToken: CART_INITIAL_STATE.apiToken,
        shopHash: storeActiveShopHash.id,
        partialBillAudit: partialPay,
        billNo: billDetails.billNo,
        custId: billCustomerDetails.custId,
        custMob: billCustomerDetails.custMob,
        custEmail: billCustomerDetails.custEmail,
        address: billCustomerDetails.address,
        custName: billCustomerDetails.custName,
        custGstDetails: billCustomerDetails.custGstDetails,
        custCompanyName: billCustomerDetails.custCompanyName,
      };

      let saveBillData = { jcJson };
      //printLog("updatePartial", saveBillData);
      handleDialogClose();
      await snpAxios
        .post(custSaveUrl, saveBillData)
        .then((response) => {
          //printLog("updatePartial => ", response.data);
          loader.hide();
          if (response.data.status === SUCCESS) {
            //TBC
            dispatch(
              updateBillPartialPaymentDetails({
                partiallyPaid: true,
                duesAmt:
                  billPartialPaymentDetails.duesAmt - partialPay.partialAmt,
              })
            );
            setPrintDetails({
              shopPrint: response.data.jcJson.shopprint,
              custPrint: response.data.jcJson.custprint,
            });

            if (
              !response.data.jcJson.custprint.includes("Successfully Print")
            ) {
              //  
              setShowCustCopyDialog(true);
            } else
              handleInvoicePrint({
                printRef: response.data.jcJson.custprint,
                name: "cust",
                apiToken: CART_INITIAL_STATE.apiToken,
                shopId: storeActiveShopHash.id,
                billNo: billDetails.billNo,
                backendBaseUrl: storeApiUrl.BACKEND_BASE_URL,
                printOptions: { isMobile: isMobile || isTablet },
                //setShowCustCopyDialog, // optional
              });
          }
        })
        .catch((error) => {
          //printLog("error : ", error);
          loader.hide();
          //window.location.href = "#/error";
        });
    }
  };

  const renderDialogAction = () => {
    return (
      <>
        <SnpButton variant="contained" color="primary" onClick={updatePartial}>
          Submit
        </SnpButton>

        <DismissButton
          variant="contained"
          color="primary"
          onClick={handleDialogClose}
        >
          Cancel
        </DismissButton>
      </>
    );
  };

  const handleDialogClose = () => {
    setShowDialog(false);
    setPartialPay(INITIAL_PARTIAL_PAY);
  };

  return (
    <div>
      <DialogBox
        showDialog={showDialog}
        title={"Partial Bill Update"}
        onClose={handleDialogClose}
        dialogContent={renderClearDues()}
        dialogActions={renderDialogAction()}
      />
    </div>
  );
};

export default PartialPayDialog;
